import React, { useState, useEffect } from "react";

const Popup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const popupTimer = 3000;

  useEffect(() => {
    const showIt = () => {
      setIsVisible(true);
    };

    const checkSurveyOpened = () => {
      const surveyOpen = localStorage.getItem("surveyOpen") || false;
      if (!surveyOpen) {
        setTimeout(showIt, popupTimer);
      }
    };

    checkSurveyOpened();
  }, []);

  const closeModal = () => {
    setIsVisible(false);
    localStorage.setItem("surveyOpen", true);
  };

  const openSurvey = () => {
    window.location.href = "https://educacionlaboral.com.do/encuesta";
    closeModal();
  };

  return (
    <div
      id="popup"
      className={`fixed inset-0 flex items-center justify-center z-50 ${
        isVisible ? "flex" : "hidden"
      }`}
    >
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300"></div>
      <div
        className={`modal_main relative text-center p-8 md:p-12 bg-cover bg-center rounded-lg transition-transform transform ${
          isVisible ? "translate-y-0" : "translate-y-full"
        } bg-gradient-to-b from-black/60 to-[#170A2D] max-w-3xl max-h-full w-full mx-4 md:mx-0 z-50`}
      >
        <div
          className="inline-flex bg-[#403ab4] rounded-sm text-white text-2xl absolute top-8 right-8 cursor-pointer hover:bg-[#1e1976] transition-colors"
          title="Close"
          onClick={closeModal}
        >
          <i className="bx bx-x"></i>
        </div>
        <h1 className="text-3xl md:text-6xl font-bold text-white">
          Valoramos tu opinión
        </h1>
        <p className="mt-6 mb-12 text-lg text-white">
          ¿Quisieras contribuir a la mejora de Educación Laboral? Ayúdanos
          haciendo clic en Realizar Encuesta.
        </p>
        <button
          className="block w-11/12 mx-auto bg-[#403ab4] text-white py-4 rounded-md transition-colors hover:bg-[#1e1976]"
          onClick={openSurvey}
        >
          Realizar Encuesta
        </button>
        <button
          className="block w-11/12 mx-auto mt-4 text-white py-4 rounded-md border border-white transition-colors hover:text-gray-400"
          onClick={closeModal}
        >
          No Gracias
        </button>
      </div>
    </div>
  );
};

export default Popup;
